/* eslint-disable */
import { makeStyles } from '@material-ui/core/styles';
import styled from "styled-components";

export const useStyles = makeStyles({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  paper: {
    width: "700px",
    minHeight: "280px",
    background: "white",
    borderRadius: "30px",
    display: "flex",
    flexDirection: "column",
    gap: "30px",
    alignItems: "center",
    paddingLeft: "10%",
    paddingRight: "10%",
    paddingTop: "30px",
    paddingBottom: "30px",
    ['@media (max-width: 880px)']: {
      width: "80%"
    },
    ['@media (max-width: 520px)']: {
      width: "90%",
    }
  },
  paperSecondary: {
    width: "750px",
    minHeight: "300px",
    background: "white",
    borderRadius: "30px",
    margin: "auto",
    display: "flex",
    flexDirection: "row",
    paddingRight: "40px",
    gap: "40px",
    overflow: "hidden",
    ['@media (max-width: 880px)']: {
      width: "80%",
      paddingRight: "30px",
      gap: "30px"
    },
    ['@media (max-width: 450px)']: {
      width: "90%",
      paddingRight: "30px",
      gap: "30px"
    }
  }
});